<template>
  <div>
    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="lg"
      title="Selecione o motorista"
    >
      <base-imput-logic
        class="ml-0"
        :options="options"
        :value.sync="valueSelected"
        @onDataChange="onDataChange(valueSelected)"
      ></base-imput-logic>

      <!-- {{ model }} -->
      <!-- {{ dataPrazo }} -->

      <div v-for="field in driverFields" :key="field.fieldId">
        <!-- {{ field }} -->
        <label v-if="field.type != 2" for="getFieldIdInputName">
          <b-row>
            <b-col cols="12" md="auto">{{ field.fieldName }}</b-col>
            <b-col class="required" v-if="field.required">*</b-col>
          </b-row>
        </label>
        <b-input-group v-if="valueSelected == 1">
          <v-select
            v-if="field.type == 9024"
            class="select-integration-list"
            label="text"
            :value="field.selectedValue"
            :options="model.drivers"
            :filterable="false"
            @input="vehiclesOptions"
          ></v-select>
          <multiselect
            v-if="field.type == 9025"
            id="selectSteps"
            class="select-field"
            v-model="field.selectedValue"
            label="text"
            track-by="value"
            placeholder=""
            :showLabels="false"
            :multiple="false"
            :options="avaliableVehicles"
            disabled
          >
          </multiselect>
        </b-input-group>
        <b-input-group v-if="valueSelected == 2">
          <select-integration-list
            v-if="field.type != 2"
            id="perPageSelect"
            :fieldId="field.fieldId"
            :value.sync="field.value"
            :selected-value.sync="field.selectedValue"
          >
          </select-integration-list>
        </b-input-group>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <div class="right">
          <div v-if="submitted">
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>{{ $t("geral.savingData") }}</strong>
            </div>
          </div>
          <b-button variant="green" @click="ok" :disabled="submitted">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "TripDriveModal",
  props: {
    driverFields: Array,
  },
  components: {
    BaseImputLogic: () => import("@/components_rms/base/BaseImputLogic.vue"),
    SelectIntegrationList: () =>
      import("@/components_rms/integrations/SelectIntegrationList.vue"),
  },
  data() {
    return {
      submitted: false,
      options: [
        { text: "Disponíveis", value: "1", selected: true },
        { text: "Ativos", value: "2", selected: false },
      ],
      valueSelected: "",
      avaliableVehicles: [],
      avaliableDrivers: [],
      dataPrazo: {},
      model: {},
    };
  },

  methods: {
    openModal() {
      this.avaliableVehicles = [];
      this.avaliableDrivers = [];
      this.valueSelected = "1";
      this.driverFields.forEach((field) => {
        if (field.fieldName == "Data Prazo") {
          this.dataPrazo = field;
        }
      });
      this.loadOptionsAvaliableDrivers();
      this.$refs.openModal.show();
    },
    vehiclesOptions(driver) {
      let driverVehicle = [];
      this.model.plates.forEach((vehicle) => {
        if (vehicle.driver == driver.text) {
          driverVehicle = vehicle.vehicles;
        }
      });
      this.driverFields.forEach((field) => {
        // console.log(field);
        if (field.type == 9024) {
          field.selectedValue = driver;
          field.value = driver.text;
        } else if (field.fieldName == "Veículo") {
          field.selectedValue = driverVehicle[0];
        } else if (field.fieldName == "Carreta 1") {
          field.selectedValue = driverVehicle[1];
        } else if (field.fieldName == "Carreta 2") {
          field.selectedValue = driverVehicle[2];
        }
      });
      this.$emit("update:driverFields", this.driverFields);
    },
    onDataChange(value) {
      console.log(value);
    },

    loadOptionsAvaliableDrivers() {
      this.$apiWorkflow
        .get("/shlog/avaliable/drivers/" + this.dataPrazo.value)
        .then((response) => {
          this.model = response.data;
        })
        .catch((error) => {
          this.avaliableDrivers = [];
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            console.log(error);
          }
        });
    },
  },
};
</script>

<style scoped>
.right {
  text-align: right;
  width: 100%;
}
.select-integration-list {
  width: 100%;
}
</style>